import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';

import { ICamera } from '../../../../../../models/types';
import { paths } from '../../../../../Root/paths';

import Tooltip from '../../../../../../components_/Tooltip';
import DrawerContentItemCamera from '../../../../../../components_/Drawer/DrawerContentItemCamera';
import { Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';

interface IProps {
  item: ICamera;
  setMarkerEditMode: () => void;
}

const Card: FC<IProps> = ({ item, setMarkerEditMode }) => {
  const { id } = item || {};

  const history = useHistory();

  const handleEditClick = () => {
    history.push(paths.map.office.cameras.edit(id));
    setMarkerEditMode();
  };

  return (
    <DrawerContentItemCamera
      camera={item}
      variant="card"
      action={
        <Tooltip id="tooltipEdit" size="s" label="Редактировать">
          <Button id="buttonEdit" type={'text'} icon={<EditOutlined />} onClick={handleEditClick} />
        </Tooltip>
      }
    />
  );
};

export default Card;
